import React from "react";
import { Button, Spin } from "antd";
import { CheckOutlined } from "@ant-design/icons";
import styles from "./style.module.scss";
import { MCP_PRO_MONTHLY_PRICE_USD, MCP_SALES_EMAIL } from "util/mcpSetup";

// Every MCP scope grants the same read-only tools plus Advisor questions.
const SCOPE_LINES = ["mcp_connector.consent_scope_read", "mcp_connector.consent_scope_advisor"];

const Representation = ({ t, loading, error, info, submitting, onApprove, onDeny }) => {
  if (loading) {
    return (
      <div className={styles.page}>
        <Spin size="large" />
      </div>
    );
  }

  if (!info) {
    return (
      <div className={styles.page}>
        <div className={styles.card}>
          <h1 className={styles.title}>{t("mcp_connector.consent_invalid")}</h1>
          {error && <p className={styles.muted}>{error}</p>}
        </div>
      </div>
    );
  }

  const entitled = Boolean(info.mcp_pro && info.mcp_pro.entitled);
  const client = info.client_name;

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <img className={styles.logo} src="/assets/settings/pivony-icon.svg" alt="Pivony" />
        <h1 className={styles.title}>{t("mcp_connector.consent_title", { client })}</h1>
        <p className={styles.muted}>
          {t("mcp_connector.consent_intro", { client, email: info.user_email })}
        </p>

        {entitled ? (
          <>
            <p className={styles.label}>{t("mcp_connector.consent_can")}</p>
            <ul className={styles.scopes}>
              {SCOPE_LINES.map((key) => (
                <li key={key}>
                  <CheckOutlined className={styles.check} />
                  {t(key)}
                </li>
              ))}
            </ul>
            <p className={styles.redirect}>
              {t("mcp_connector.consent_redirect", { host: info.redirect_host })}
            </p>
          </>
        ) : (
          <div className={styles.notice}>
            <strong>{t("mcp_connector.pro_missing_title")}</strong>
            <p>
              {t("mcp_connector.pro_missing_body", {
                price: `$${MCP_PRO_MONTHLY_PRICE_USD.toLocaleString("en-US")}`,
              })}
            </p>
            <a href={`mailto:${MCP_SALES_EMAIL}?subject=${encodeURIComponent("Pivony MCP Pro")}`}>
              {MCP_SALES_EMAIL}
            </a>
          </div>
        )}

        {error && <p className={styles.error}>{error}</p>}

        <div className={styles.actions}>
          <Button onClick={onDeny} disabled={submitting}>
            {t("mcp_connector.consent_deny")}
          </Button>
          {entitled && (
            <Button type="primary" onClick={onApprove} loading={submitting}>
              {t("mcp_connector.consent_approve")}
            </Button>
          )}
        </div>
        <p className={styles.footnote}>{t("mcp_connector.consent_revoke_hint", { client })}</p>
      </div>
    </div>
  );
};

export default Representation;
